module.exports = __webpack_public_path__ + "static/media/Home Page_website-26.cfad0137.png";